export default __webpack_public_path__ + "d2fc5b67fb5e2bbd63117ce56e9585b8.woff";